<template>
  <div class="courseCatalogue-container">
    <div class="courseCatalogue" v-for="(item ,index) in chapterArr" :key='index'>
      <div class="chapter color-black f18 fbox fbox-ac" >
        <!-- <span>第一节</span> -->
        <span>{{item.chapter}}</span>
      </div>
      <div class="joint fbox fbox-ac fbox-jb color-black f18" v-for="(t, i) in item.course" :key='i' @click="look(t)">
        <div>
          <!-- <span>第1节</span> -->
          <span v-if="kernelArr[t]">{{kernelArr[t].knobble}}</span>
          <span class="free" v-if="kernelArr[t] && kernelArr[t].free">免费试学</span>
        </div>
        <div v-if="kernelArr[t]">{{kernelArr[t].duration || '暂无'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'courseCatalogue',
  props: ['chapterArr', 'kernelArr', 'modal', 'text', 'msg'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    ok () {
      this.$emit('ok')
    },
    cancel () {
      this.$emit('cancel')
    },
    look (e) {
      if (!this.kernelArr[e].free) {
        this.$Message.warning('请购买后观看!')
        return
      }
      this.$push({
        path: '/watch',
        query: {
          courseId: this.$route.query.id,
          knobbleId: this.kernelArr[e].objectId
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.courseCatalogue-container{
  width: 100%;
  .courseCatalogue{
    margin-bottom: 20px;
    .chapter{
      width: 100%;
      height: 64px;
      background-color: #F5F6F6;
      padding-left: 40px;
      position: relative;
      box-sizing: border-box;
      &::before{
        content: "";
        width: 0;
        height: 30px;
        border-left: 6px solid #28B28B;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      span{
        margin-right: 30px;
      }
    }
    .joint{
      width: 100%;
      height: 90px;
      padding: 0 38px 0 57px;
      box-sizing: border-box;
      border-bottom: 1px solid #F5F6F6;
      cursor: pointer;
      span{
        margin-right: 35px;
      }
      .free{
        display: inline-block;
        width: 72px;
        height: 28px;
        line-height: 28px;
        background: #EA3553;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
  }
}
@media(max-width: 992px) {
  .courseCatalogue-container{
    width: 100%;
    .courseCatalogue{
      margin-bottom: 20px;
      .chapter{
        height: 44px;
        padding-left: 20px;
        font-size: 16px;
        &::before{
          content: "";
          width: 0;
          height: 20px;
          border-left: 6px solid #28B28B;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        span{
          margin-right: 30px;
        }
      }
      .joint{
        width: 100%;
        height: 60px;
        padding: 0 0px 0 0px;
        font-size: 14px;
        span{
          margin-right: 15px;
        }
        .free{
          width: 62px;
          height: 25px;
          line-height: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
